import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next/initReactI18next";
import { getOptions } from "./settings";
import { FETCH_SETTINGS, LOCALIZATION_URL } from "../../lib/constants";
import apiFetch from "../../lib/fetch";
import getTDefaultOptions from "./utilts";

const initI18next = async (lng, ns) => {
  // on server side we create a new instance for each render, because during compilation everything seems to be executed in parallel
  const i18nInstance = createInstance();
  await i18nInstance
    .use(initReactI18next)
    .use({
      type: "backend",
      read: async (language, namespace, callback) => {
        try {
        const data = await apiFetch({
          externalURL: `${LOCALIZATION_URL}/locale?namespace=${namespace}&lng=${language}`,
          headers: {
            "Cache-Control": "no-cache"
          }
        });
          callback(null, data);
        } catch (e) {
          callback(e, {});
        }
      },
      create: () => {},
      init: () => {},
    })
    .init({
      ...getOptions(lng, ns),
      interpolation: {
        escapeValue: false,
      },
    });
  return i18nInstance;
};

export async function useServerTranslation(lng, ns, options = {}) {
  const i18nextInstance = await initI18next(lng, ns);
  const site = await apiFetch({ route: "sites", tags: ['sites'] });

  const originalT = i18nextInstance.getFixedT(
    lng,
    Array.isArray(ns) ? ns[0] : ns,
    options.keyPrefix,
  );

  const newT = (key, options = {}) => {
    const tOptions = getTDefaultOptions(key, options, site);

    return originalT(key, tOptions);
  };

  return {
    t: newT,
    i18n: i18nextInstance,
  };
}
